import { z } from 'zod';

const availabilitySchema = z.object({
   availability: z.number().min(1, 'Availability is required'),
});

export type TAvailability = z.infer<typeof availabilitySchema>;
export { availabilitySchema };
